import React from "react";
import { IPage } from "api/entities/page";
import Table, {
  IColumnDefinition,
  TableSelected,
} from "components/shared-ui/table/table";
import styles from "./group-table.module.scss";
import { useNavigate } from "react-router-dom";
import tableStyles from "../../shared-ui/table/table.module.scss";
import { routeUtils } from "utils/route-utils";
import { IAMGroupSortField, IIAMGroup } from "api/entities/iam-groups";
import { IIAMEntityRequestParams } from "api/entities/iam-entity";
import { MoreOption } from "../../shared-ui/iam/moreoption";

export interface IAMGroupTableProps {
  isLoading: boolean;
  page: IPage<IIAMGroup>;
  requestParams: IIAMEntityRequestParams<IAMGroupSortField>;
  setRequestParams: (data: IIAMEntityRequestParams<IAMGroupSortField>) => void;

  selection?: TableSelected<IIAMGroup>;
  onSelectionChanged?: (selection: TableSelected<IIAMGroup>) => void;
  onSelectAll?: () => void;

  isRowClickable?: boolean;
  hasManageColumn?: boolean;
}

export const IAMGroupTable = (props: IAMGroupTableProps) => {
  const navigate = useNavigate();
  const columns: IColumnDefinition<IIAMGroup, IAMGroupSortField>[] = [
    {
      label: "Name",
      className: styles["col--name"],
      formatter: (row) => row.GroupName,
      sortKey: IAMGroupSortField.GroupName,
    },
    {
      label: "ARN",
      className: styles["col--arn"],
      formatter: (row) => row.Arn,
      sortKey: IAMGroupSortField.ARN,
    },
    {
      label: "Created At",
      className: styles["col--create-date"],
      formatter: (row) => new Date(row.CreateDate).toLocaleString(),
      sortKey: IAMGroupSortField.CreateDate,
    },
  ];

  if (props.hasManageColumn) {
    columns.push({
      label: "Manage",
      className: tableStyles["col--manage"],
      formatter: (row) => (
        <MoreOption
          data={row}
          routeGetter={routeUtils.getRouteToIAMGroupDetails}
        />
      ),
    });
  }

  return (
    <Table
      testId="iam-group-table"
      columns={columns}
      hideCheckbox={!props.selection}
      loading={props.isLoading}
      rows={props.page.data}
      totalRows={props.page.count}
      onRowClick={(row) =>
        !!props.isRowClickable &&
        navigate(routeUtils.getRouteToIAMGroupDetails(row.id))
      }
      selected={props.selection}
      onSetSelected={props.onSelectionChanged}
      onSelectAll={props.onSelectAll}
      responsive
      requestParams={props.requestParams}
    />
  );
};
